module.exports = __webpack_public_path__ + "static/img/user.7cfc08d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/user.png
// module id = 273
// module chunks = 313